import g from "../globals/variables";
import scroll from "../layout/scroll";
import flatpickr from "flatpickr";

const Filter = (target) => {

  let filtersAgeActive = [];
  let filtersLocationActive = [];
  let filtersSexActive = [];
  let filtersMediaActive = [];

  const el = {
    filters: target,
    filtersTarget: document.querySelector(".filters__target"),
    filtersMedia: document.querySelector(".filters__media"),
    offerWraps: document.querySelectorAll(".offers__wrap"),
  };

  const method = {

    init: () => {

      if (el.filters) {
        const nextSection = el.filters.parentElement.parentElement.parentElement.nextElementSibling as HTMLElement;
        if (nextSection.classList.contains("offers")) {
          nextSection.setAttribute("style", "transform: translateY(100%); transition: none;");
          setTimeout(() => {
            nextSection.setAttribute("style", "transform: none; transition: none;");
            setTimeout(() => {
              nextSection.removeAttribute("style");
              g.scroll.update();
            }, 10);
          }, 1500);
        }
        method.options();
        method.dateFilter();
      }
    },

    options: () => {

      if (el.filtersTarget != null) {
        const checkboxesTarget = el.filtersTarget.querySelectorAll('input[type="checkbox"]');

          for (let i = 0; i < checkboxesTarget.length; i++) {
            const checkbox = <HTMLInputElement> checkboxesTarget[i];
            const checkboxValue = checkbox.getAttribute('data-value');
            const checkboxSplit = checkbox.getAttribute('data-split');

            checkbox.addEventListener('change', () => {
              if (checkbox.checked) {
                if (checkboxSplit == "0") {
                  filtersSexActive.push(checkboxValue);
                }
                else if (checkboxSplit == "1") {
                  filtersAgeActive.push(checkboxValue);
                }
                else if (checkboxSplit == "2") {
                  filtersLocationActive.push(checkboxValue);
                }
              }
              else {
                  if (checkboxSplit == "0") {
                    let index = filtersSexActive.indexOf(checkboxValue);
                    if (index > -1) {
                      filtersSexActive.splice(index, 1);
                    }
                  }
                  else if (checkboxSplit == "1") {
                    let index = filtersAgeActive.indexOf(checkboxValue);
                    if (index > -1) {
                      filtersAgeActive.splice(index, 1);
                    }
                  }
                  else if (checkboxSplit == "2") {
                    let index = filtersLocationActive.indexOf(checkboxValue);
                    if (index > -1) {
                      filtersLocationActive.splice(index, 1);
                    }
                  }
              
              }
              method.render();
            })
          }
        }

      if (el.filtersMedia != null) {
        const checkboxesMedia = el.filtersMedia.querySelectorAll('input[type="checkbox"]');

        for (let i = 0; i < checkboxesMedia.length; i++) {
          const checkbox = <HTMLInputElement>checkboxesMedia[i];
          const checkboxValue = checkbox.getAttribute('data-value');

          checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
              filtersMediaActive.push(checkboxValue);
            }
            else {
              let index = filtersMediaActive.indexOf(checkboxValue);
              if (index > -1) {
                filtersMediaActive.splice(index, 1);
              }
            }
            method.render();
          })
        }
      }
    },

    dateFilter: () => {
      var dateFrom = <HTMLElement>document.querySelector('.filters__dateFrom');
      var fromDate: any = null;
      var dateTo = <HTMLElement>document.querySelector('.filters__dateTo');
      var toDate: any = null;

      if (dateFrom != null && dateTo != null) {
        flatpickr(dateFrom, {
          dateFormat: "d-m-y",
          onChange: (selectedDates, dateStr, instance) => {
            fromDate = selectedDates[0];
            method.render(fromDate, toDate);
          },
        });

        flatpickr(dateTo, {
          dateFormat: "d-m-y",
          onChange: (selectedDates, dateStr, instance) => {
            toDate = selectedDates[0];
            method.render(fromDate, toDate);
          },
        });
      }
    },

    render: (fromDate: any = null, toDate: any = null ) => {
      for (let i = 0; i < el.offerWraps.length; i++) {
        let offerWrap = el.offerWraps[i];
        let offer = offerWrap.querySelector('.offer');

        let offerAgeFilters = offer.getAttribute('data-filter-age-attributes').split(',');
        let offerLocationFilters = offer.getAttribute('data-filter-location-attributes').split(',');
        let offerSexFilters = offer.getAttribute('data-filter-sex-attributes').split(',');
        let offerMediaFilters = offer.getAttribute('data-filter-media-attributes').split(',');

        let showAge = filtersAgeActive.filter(value => offerAgeFilters.includes(value));
        let showLocation = filtersLocationActive.filter(value => offerLocationFilters.includes(value));
        let showSex = filtersSexActive.filter(value => offerSexFilters.includes(value));
        let showMedia = filtersMediaActive.filter(value => offerMediaFilters.includes(value));

        let offerDate = offer.getAttribute('data-filter-date-attributes');
        let itemDate = new Date(offerDate || "");
        let filterFrom = new Date(fromDate || "");
        let filterTo = new Date(toDate || "");
    
        if ((filtersAgeActive.length == 0 || showAge.length > 0) &&
            (filtersLocationActive.length == 0 || showLocation.length > 0) &&
            (filtersSexActive.length == 0 || showSex.length > 0) && 
            (filtersMediaActive.length == 0 || showMedia.length > 0) &&
            (offerDate == "0001-01-01" || ((fromDate == null || itemDate >= filterFrom) && (toDate == null || itemDate <= filterTo)))
          ) {
          //TODO if datepicker is filled than reorder elements by date
          offerWrap.classList.remove('hide');
        }
        else {
          offerWrap.classList.add('hide');
        }
      }

      scroll.reinitScroll();
    },

  };

  method.init();
};

export default Filter;
